// Utilidades compartidas: visibilidad condicional de campos y gate de etapas.

export const isFieldVisible = (field, customFields) => {
  const dep = field?.depends_on_field;
  if (!dep) return true;
  const vals = (field.depends_on_values || []).map(String);
  if (vals.length === 0) return true;
  const actual = (customFields || {})[dep];
  if (Array.isArray(actual)) return actual.some((v) => vals.includes(String(v)));
  return vals.includes(String(actual));
};

const isEmpty = (v) => v === undefined || v === null || v === "" || v === false || (Array.isArray(v) && v.length === 0);

export const getMissingStageFields = (stage, pipelineFields, card) => {
  const cf = card?.custom_fields || {};
  const byName = Object.fromEntries((pipelineFields || []).map((f) => [f.name, f]));
  const missing = [];
  const req = stage?.required_fields || [];
  for (const name of req) {
    if (name === "expected_close_date") {
      if (!card?.expected_close_date) missing.push({ name, label: "Fecha de cierre esperada", core: true });
      continue;
    }
    const f = byName[name];
    if (!f || !isFieldVisible(f, cf)) continue;
    if (isEmpty(cf[name])) missing.push({ name, label: f.label || name, field: f });
  }
  // Campos REQUERIDOS con "Visible solo en etapa(s)": exigidos al entrar a una de sus etapas marcadas
  const stageId = stage?.id;
  for (const f of pipelineFields || []) {
    const vis = f.visible_in_stages || [];
    if (!f.required || !vis.length || !vis.includes(stageId)) continue;
    if (missing.some((m) => m.name === f.name)) continue;
    if (!isFieldVisible(f, cf)) continue;
    if (isEmpty(cf[f.name])) missing.push({ name: f.name, label: f.label || f.name, field: f });
  }
  return missing;
};
